import React from 'react';
import moment from 'moment';
import { Spring } from 'react-spring';
import Loading from '../../components/Loading/Loading';
import HeaderComponent from '../../components/Header';
import { slotActions, appointmentActions, sessionActions, counsellorActions, authActions } from '../../store/actions';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import notfound from '../../static/images/notfound.png';
import allowcamera from '../../static/images/allowcamera.png';
import { history } from '../../helpers';
import '../../static/css/styles.css';
import '../../components/Modal/modal.css';
import { constants } from '../../Constants';
import EditAppointmentModal from '../../components/EditAppointmentModal';

class RequestAppointment extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			slot: this.props.match.params.date_time,
            patientId: this.props.match.params.patient_id,
            loading:true,
        };
    }
    componentWillMount(){
        const {user, auth} = this.props;
        const {slot,patientId} = this.state;
        if(user && auth.logInSuccess)
            this.props.requestAppointment(moment(slot, 'YYYY-MM-DD hh:mm:ss').utc().format(), patientId);
        else    
             history.push({
                 pathName:'/',
                 state:{
                     requestSession:true,
                     slot,
                     patientId
                 }
                })
    }

	render() {
		const { loading} = this.props;
        return(
            loading ? <Loading /> : 
            <div></div>
        )
	}
}

function mapStateToProps(state) {
	const { session, auth, alert } = state;
	const { appointments, loading, updateStatus } = state.appointments;
	const { counsellorStatus } = state.counsellorStatus;
	const { user } = auth;
	return {
        auth,
		user,
		alert,
		appointments,
		session,
		counsellorStatus,
		loading,
		updateStatus,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
		requestAppointment: (schedule, patientId) => {
			dispatch(appointmentActions.counsellorRequestAppointment(schedule, patientId))
		}	
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestAppointment);



// WEBPACK FOOTER //
// ./src/components/RequestAppointment/index.js